export default {
	hasResetRequest: false,
	codeError: false,
	requestSent: false,
	resetSent: false,
	loginStatus: false,
	sendingLoginAuth: false,
	userAccountList: [],
	hasCodeEmailed: false,
	loginId: 0,
	resetError: false,
	resetComplete: false,
	hasAccountSelect: false,
	loginIdFinal: 0,
	globalApp: '',
  tokenList: [],
  appUrl: ''
}
